<template>
  <div v-show="hasSimilarEntries && hasDisplayableGroups" class="col-12 quick-v-attrs-out">
    <div class="row">
      <div v-for="similarGroup in usedSimilarValuesByGroupMerged" :key="similarGroup.similarGroupId"
           class="col-12 quick-v-attr-row">
        <similar-image-selector
          v-if="similarGroup.similarDisplayType === 'image' && shouldDisplayGroup(similarGroup)"
          :similar-product-group-combos="similarProductGroupCombos"
          :current-similar-product-group-combo="similarProductGroupCombos[productData.productId]"
          :default-value="getDefaultValueForSimilarGroupType('image', similarGroup.similarGroupId)"
          :force-display-all-values="Boolean(similarGroup.similarGroupForceDisplayAllValues)"
          :similar-group="similarGroup"
        >
        </similar-image-selector>
        <similar-hex-selector
          v-if="similarGroup.similarDisplayType === 'hex-color' && shouldDisplayGroup(similarGroup)"
          :similar-product-group-combos="similarProductGroupCombos"
          :current-similar-product-group-combo="similarProductGroupCombos[productData.productId]"
          :default-value="getDefaultValueForSimilarGroupType('hex-color', similarGroup.similarGroupId)"
          :force-display-all-values="Boolean(similarGroup.similarGroupForceDisplayAllValues)"
          :similar-group="similarGroup"></similar-hex-selector>
        <similar-text-selector
          v-if="shouldDisplayTextSelector(similarGroup.similarDisplayType) && shouldDisplayGroup(similarGroup)"
          :similar-product-group-combos="similarProductGroupCombos"
          :current-similar-product-group-combo="similarProductGroupCombos[productData.productId]"
          :default-value="getDefaultValueForSimilarGroupType('text', similarGroup.similarGroupId)"
          :force-display-all-values="Boolean(similarGroup.similarGroupForceDisplayAllValues)"
          :similar-group="similarGroup"></similar-text-selector>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../vue/store'
import SimilarTextSelector from './SimilarTextSelector'
import SimilarHexSelector from './SimilarHexSelector'
import { find, pickBy, some, uniq } from 'lodash'
import SimilarImageSelector from './SimilarImageSelector'

export default {
  name: 'SimilarSelect',
  props: ['productId'],
  components: {
    SimilarTextSelector,
    SimilarHexSelector,
    SimilarImageSelector
  },
  data () {
    return {
      version: '0.0.1',
      selectedOptions: [],
      selectedProductCodeId: null
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.productId)
    },
    hasSimilarEntries () {
      return some(this.productData.productCodes, (e) => {
        if (e.productCodeSimilars !== undefined) {
          return e.productCodeSimilars.length > 0
        }
        return []
      })
    },
    hasDisplayableGroups () {
      return some(this.usedSimilarValuesByGroupMerged, (group) => {
        return this.shouldDisplayGroup(group)
      })
    },
    usedSimilarValuesByGroup () {
      return store.getters.getUsedSimilarValuesByGroup(this.productId)
    },
    usedSimilarValuesByGroupMerged () {
      return store.getters.getUsedSimilarValuesByGroupMerged(this.productId)
        .sort((a, b) => parseInt(a.similarGroupOrder) - parseInt(b.similarGroupOrder))
    },
    currentProductRelatedSimilarEntries () {
      const productRelatedSimilarEntries = store.getters.getRelatedSimilarData

      return productRelatedSimilarEntries.map(item => {
        return {
          productId: Number(item.product_id),
          similarId: item.similar_value_id,
          similarGroupId: item.similar_group_id,
          stock: item.availabilityStock
        }
      })
    },
    currentProductSimilarEntries () {
      const productSimilar = this.usedSimilarValuesByGroup

      const productSimilarMapped = productSimilar.map(item => {
        const similarGroupId = item.similarGroupId
        return item.similars.map(similar => {
          return {
            productId: this.productId,
            similarId: similar.similarId,
            similarGroupId: similarGroupId,
            stock: this.productData.productStock
          }
        })
      })

      const productSimilarMappedFinal = []
      productSimilarMapped.reduce((current, next) => {
        productSimilarMappedFinal.push(...next)
      }, {})

      return productSimilarMappedFinal
    },
    similarProductGroupCombos () {
      const currentProductRelatedSimilarEntries = this.currentProductRelatedSimilarEntries
      const currentProductSimilarEntries = this.currentProductSimilarEntries

      const merged = [...currentProductRelatedSimilarEntries, ...currentProductSimilarEntries]

      const mapped = {}

      for (const productEntry of merged) {
        if (!(productEntry.productId in mapped)) {
          mapped[productEntry.productId] = []
        }
        const mappedEntryData = pickBy(productEntry, (item, key) => [
          'similarGroupId',
          'similarId',
          'stock'
        ].includes(key))
        mapped[productEntry.productId].push(mappedEntryData)
        mapped[productEntry.productId] = uniq(mapped[productEntry.productId])
      }

      return mapped
    }
  },
  methods: {
    getDefaultValueForSimilarGroupType (groupTypeName, groupId) {
      const currentProductGroupValues = this.usedSimilarValuesByGroup
      const group = find(currentProductGroupValues, (similar) => {
        return similar.similarDisplayType === groupTypeName && similar.similarGroupId === groupId
      })
      if (group !== undefined) {
        return group.similars[0].similarName
      }
      return null
    },
    shouldDisplayTextSelector (similarDisplayType) {
      return similarDisplayType === 'text' || similarDisplayType === 'text-range-per-value' || similarDisplayType === 'text-range-per-count'
    },
    shouldDisplayGroup (similarGroup) {
      return similarGroup.similarGroupDisplayPosition === 0 || similarGroup.similarGroupDisplayPosition === 1
    }
  }
}
</script>
